import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
console.log("Enabled Direct Uploads")
